import { Component, SimpleChanges } from '@angular/core';

import { HotkeysService, Hotkey } from '@ngneat/hotkeys';
import { VbNestedMenuComponent } from '../shared/VbNestedMenuComponent';

@Component({
	selector: 'vb-hotkeys-help',
	template: `
		<div
			[ngClass]="menuButtonStyles.dropdown"
			dropdown
			#dropdown="bs-dropdown"
			[autoClose]="true"
			[insideClick]="false"
			placement="top right"
			[dropup]="true">
			<ul
				[ngClass]="menuButtonStyles.dropdownMenu"
				class="playerSettingsSubmenu"
				*dropdownMenu
				#vbDropdownMenu
				aria-labelledby="buttonMenuHotkeys"
				id="dropdownHotkeysMenu"
				role="menu"
				tabindex="0">
				<li role="none">
					<button type="button"
						role="menuitem"
						class="dropdown-item btn-link"
						[ngClass]="menuButtonStyles.backToMainMenuItem"
						(click)="hideMenu()">
						<span>{{ translations.keyboardShortcuts }}</span>
					</button>
				</li>
				<li role="none" class="divider dropdown-divider"></li>
				<li role="none"
					*ngFor="let key of hotkeys">
					<button type="button"
						role="menuitem"
						class="dropdown-item btn-link"
						[ngClass]="menuButtonStyles.readonly"
						*ngIf="key.description">
						<span>{{ key.description }}</span>
					</button>
				</li>
			</ul>
		</div>
	`
})
export class VbHotkeysHelpComponent extends VbNestedMenuComponent {
	public hotkeys: Hotkey[];

	constructor(
		private HotkeysService: HotkeysService
	){
		super();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes.activateDropdown && this.activateDropdown) {
			this.assignHotKeys();
		}
	}

	public assignHotKeys(): void {
		this.hotkeys = this.HotkeysService.getHotkeys()
			.filter(hotkey => hotkey.description)
			.sort((a, b) => a.description.localeCompare(b.description));
	}
}
